import { MenuItem, Select, Stack, Typography } from '@mui/material'
import styles from './toolPermissionsDialog.module.scss'

export default function ToolPermissionRow({ tool, onChange }) {
  return (
    <Stack direction="row" alignItems="center" gap={2} className={styles.toolRow}>
      <Typography className={styles.toolName}>{tool.name}</Typography>
      <Select size="small" value={tool.tier} onChange={(event) => onChange(tool.slug, event.target.value)} inputProps={{ 'aria-label': `Permission for ${tool.name}` }} className={styles.select}>
        <MenuItem value="allow">Always allowed</MenuItem>
        <MenuItem value="confirm">Requires approval</MenuItem>
      </Select>
    </Stack>
  )
}
